import { createAsyncThunk } from "@reduxjs/toolkit";
import { makeRequest } from "../../utilities/api";

export const getFilteredPromoters = createAsyncThunk("users/getFilteredPromoter", async (values, { rejectWithValue }) => makeRequest("/referrals/filter", "POST", values, rejectWithValue));
